import { render, staticRenderFns } from "./knowledgecategory.vue?vue&type=template&id=0136b6e8&scoped=true"
import script from "./knowledgecategory.vue?vue&type=script&lang=js"
export * from "./knowledgecategory.vue?vue&type=script&lang=js"
import style0 from "./knowledgecategory.vue?vue&type=style&index=0&id=0136b6e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0136b6e8",
  null
  
)

export default component.exports